/**
 * Multi-keyword helpers for content targets (client mirror of server/targetKeywords.js).
 */

export const KEYWORD_SEPARATOR = '|';

export const splitKeywordList = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return [];
  if (raw.includes('|')) {
    return raw
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean);
  }
  return raw
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
};

export const splitVolumeList = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return [];
  if (raw.includes('|')) {
    return raw.split('|').map((part) => part.trim());
  }
  if (raw.includes(',')) {
    const parts = raw.split(',').map((part) => part.trim());
    if (parts.every((part) => part === '' || /^-?\d+(\.\d+)?$/.test(part))) {
      return parts;
    }
  }
  return [raw.replace(/,/g, '')];
};

export const parseVolumeToken = (token) => {
  if (token === undefined || token === null || String(token).trim() === '') return null;
  const n = Number(String(token).replace(/,/g, ''));
  return Number.isFinite(n) ? Math.round(n) : null;
};

export const parseKeywordVolumePairs = (keywordValue, volumeValue) => {
  const keywords = splitKeywordList(keywordValue);
  const volumeTokens = splitVolumeList(volumeValue);
  return keywords.map((keyword, index) => ({
    keyword,
    search_volume: parseVolumeToken(volumeTokens[index])
  }));
};

export const serializeKeywordVolumePairs = (pairs) => {
  const cleaned = (Array.isArray(pairs) ? pairs : [])
    .map((pair) => ({
      keyword: String(pair?.keyword || '').trim(),
      search_volume:
        pair?.search_volume === null || pair?.search_volume === undefined || pair?.search_volume === ''
          ? null
          : Number(pair.search_volume)
    }))
    .filter((pair) => pair.keyword);

  if (cleaned.length === 0) {
    return { keyword: null, search_volume: null };
  }

  return {
    keyword: cleaned.map((pair) => pair.keyword).join(KEYWORD_SEPARATOR),
    search_volume: cleaned
      .map((pair) => (Number.isFinite(pair.search_volume) ? String(pair.search_volume) : ''))
      .join(KEYWORD_SEPARATOR)
  };
};

export const formatKeywordPairsForDisplay = (keywordValue, volumeValue) => {
  const pairs = parseKeywordVolumePairs(keywordValue, volumeValue);
  if (pairs.length === 0) return '';
  return pairs
    .map((pair) => {
      const vol = Number.isFinite(pair.search_volume)
        ? pair.search_volume.toLocaleString('en-GB')
        : '—';
      return `${pair.keyword} (${vol})`;
    })
    .join(', ');
};

export const emptyKeywordRow = () => ({ keyword: '', search_volume: '', loading: false });

export const pairsToFormRows = (keywordValue, volumeValue) => {
  const pairs = parseKeywordVolumePairs(keywordValue, volumeValue);
  if (pairs.length === 0) return [emptyKeywordRow()];
  return pairs.map((pair) => ({
    keyword: pair.keyword,
    search_volume: pair.search_volume === null ? '' : String(pair.search_volume),
    loading: false
  }));
};
